import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconHistory: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        d="M13.1001 2.00014C7.63386 2.00014 3.20242 6.48638 3.20007 12.0078H1L4.3 15.3411L7.60001 12.0078H5.40013C5.40216 7.72076 8.85538 4.22252 13.1 4.22252C17.3458 4.22252 20.7998 7.71157 20.7998 12.0001C20.7998 16.2887 17.3457 19.7778 13.1 19.7778C10.4154 19.7778 8.05051 18.3808 6.67158 16.2709L5.09323 17.8651C6.89296 20.3668 9.80422 22 13.1 22C18.5676 22 23 17.5229 23 12C23 6.47714 18.5676 2 13.1 2L13.1001 2.00014ZM17.5002 10.8892V13.1115H12V6.44481H14.2001V10.8892H17.5002Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconHistory;
